import type { ReactNode } from 'react';

import { cn } from '@core/utils/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Callers must distinguish "nothing exists yet" from "nothing matches your filters".
 * Conflating them is the most common empty-state mistake: the first wants a create
 * action, the second wants a Clear filters button, and showing the wrong one makes the
 * user think the app is broken.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center px-6 py-16 text-center', className)}
    >
      {icon && <div className="text-fg-subtle mb-4 opacity-40 [&_svg]:size-10">{icon}</div>}
      <p className="text-[17px] font-semibold tracking-[-0.01em]">{title}</p>
      {description && <p className="text-fg-muted mt-1.5 max-w-sm text-[15px]">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
